import { z } from 'zod';
import { api } from '@/lib/api';
export const pdfGuideSchema = z.object({
  kind: z.literal('pdf_learning_guide'),
  title: z.string(),
  overview: z.string(),
  steps: z.array(
    z.object({
      title: z.string(),
      goal: z.string(),
      activity: z.string(),
      pages: z.array(z.number().int().positive()),
    }),
  ),
});
export type PdfLearningGuide = z.infer<typeof pdfGuideSchema>;
export interface PdfLearningIndex {
  source_revision: string;
  digest: string;
  pages: Array<{ page: number; text: string; state: 'text' | 'needs_recognition' }>;
}
export interface PdfLearning {
  guide_available?: boolean;
  index: PdfLearningIndex | null;
  guide: PdfLearningGuide | null;
}
export const readPdfLearning = (id: string) => api<PdfLearning>(`/study/documents/${id}/learning`);
export const preparePdfLearning = (id: string) =>
  api<PdfLearningIndex>(`/study/documents/${id}/learning/prepare`, { method: 'POST' });
export function parsedPdfGuide(text: string) {
  try {
    return pdfGuideSchema.parse(JSON.parse(text));
  } catch {
    return null;
  }
}
